import { ReturnCreateApiResponse, ReturnOrderCreateDetail, ReturnOrderType } from "@jog/types"

import { AWSClient } from "./index"

export const orderClient = () => AWSClient(process.env.NEXT_PUBLIC_AWS_ORDERS_ENDPOINT || "")

export const returnOrders = (page?: { limit?: number; offset?: number }) =>
    orderClient()<{ orders: ReturnOrderType[]; total: number }>({
        method: "GET",
        uri: `/return/orders?` + (page ? `&limit=${page?.limit}&offset=${page?.offset}` : ""),
    }).then((res) => res.body)

export const returnOrderDetail = async (orderNumber: string, email: string) =>
    orderClient()<{ order: ReturnOrderType }>({
        method: "POST",
        uri: `/return/search`,
        body: { email, orderNumber },
    })

export const returnCreate = async (orderNumber: number, details: ReturnOrderCreateDetail[], awinReturn?: boolean) =>
    orderClient()<ReturnCreateApiResponse>({
        method: "POST",
        uri: `/return/${orderNumber}`,
        body: { details, awinReturn },
    })
